<template>
  <v-row justify="center" style="width:100%;margin-left:0px"
    :style="{ 
      'background-color': levelColor, 'color': Color,
      'font-family': Font, 
      'font-size': FontSize,
    }"
  >
    <v-expansion-panels accordion :loading="true"  style="border-radius: 0px !important"
        :elevation="0">
      <v-expansion-panel
        v-for="(item, i) in items.filter(x => x.ParentFolderID === parentID)"
        :key="i"
        @click="handleExpand(item)"    
        :elevation="0"
      >
        <v-expansion-panel-header
          :expand-icon="item.type==='folder' ? '' : 'mdi-menu-down'"
          :style="{ 
            'background-color': item.type==='folder' ? levelColor : 'white', 'color': item.type==='folder' ? Color : 'black',
            'font-family': Font, 
            'font-size': FontSize,
          }"
          dark
        >
         <center v-if="item.type === 'folder'">{{ getTranslation(item.Name, locale).toUpperCase() }}</center>
         <div v-else>{{ getTranslation(item.Name, locale) }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>          
          <menu-items
            :level="actualLevel"
            v-if="item.type === 'folder'"
            :items="items"
            :parentID="item.ID"
            :onExpandMenu="onExpandMenu"
            :onShowMore="onShowMore"    
            :count="item.actualCount"   
            :total="item.CountFolder || item.CountFile"     
          />
          <menu-item-pdf
            v-else
            :item="item"
            :locale="locale"
          />
          <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-if="total > count"
      style="text-align: right;margin:20px;width:100%"
    >
      <v-spacer />
      <v-btn
        text 
        @click="onShowMore(items.filter(x=>x.ID ===parentID)[0])"
        small
      >
        <div
          :style="{ 
            'color': Color,
            'font-family': Font, 
            'font-size': FontSize,
          }"
        >
          {{ count }} {{ $t('common.of', locale) }} {{ total }} [{{ $t('common.showMore', locale) }}]
        </div>
      </v-btn>
    </div>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex'
  import MenuItems from '../dfiles/MenuItems'
  import MenuItemPdf from './MenuItemPdf'
  import utils from '@/services/utils'
  export default {
    name: 'menu-items',
    components: {
      MenuItems,
      MenuItemPdf
    },
    props: {
      level: {
        type: Number,
        default: 2
      },
      items: {
        type: Array,
        required: true
      },
      parentID: {
        type: String,
        default: null
      },
      count: {
        type: Number,
        default: null
      },
      total: {
        type: Number,
        default: 0
      },
      onExpandMenu: {
        type: Function,
        required: true
      },
      onShowMore: {
        type: Function,
        required: true
      }
    },
    computed: {
      ...mapState('app',['locale', 'BGColor', 'Color', 'Font', 'FontSize']),
      actualLevel () {
        return this.level + 2
      },
      levelColor () {
        const alpha = ['FF', 'F2', 'E6', 'D9', 'CC', 'BF', 'B3', 'A6', '99', '8C', '80', '73', '66', '59', '4D', '40', '33', '26', '1A', '0D', '00']
        return this.BGColor.substring(0, 7).concat(alpha[this.level])
      }
    },
    methods: {
      getTranslation (v, locale) {
        return utils.getTranslation(v,locale)
      },
      handleExpand (v) {
        if (v.actualCount === null)this.onExpandMenu(v)
      }
    }
  }
</script>
